import { IUser } from "./user.types"

export class User implements IUser {
  constructor(
    public id: number,
    public email: string,
    public firstName: string,
    public createdAt: string,
    public signInCount: number,
    public currentSignInIp: string,
    public customerId?: number,
    public lockedAt?: string,
  ) {}
}
